import { render } from "./ActionConfig.vue?vue&type=template&id=20a0c762&scoped=true"
import script from "./ActionConfig.vue?vue&type=script&lang=ts"
export * from "./ActionConfig.vue?vue&type=script&lang=ts"

import "./ActionConfig.vue?vue&type=style&index=0&id=20a0c762&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20a0c762"

export default script